
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Tocca "Apri nel browser..."`,
's182ab2d6c997515f': `Aggiungilo alla schermata principale per un'esperienza più completa e un accesso facile.`,
's224cbcec014ef6b5': `Premi Condividi nella barra di navigazione`,
's233af3b7eb5e0364': `Aggiungi alla Home`,
's37a9e8aec5713460': `Più`,
's4c3161035f3a1413': `Premi Menu`,
's4e1e10a6ca408245': `Tocca "Aggiungi alla schermata principale"`,
's6196153c4b0c1ea0': `Installa`,
's633502f7cff4f847': `Apri il menu del tuo browser`,
's681e399d63311fba': `Mostra galleria`,
's6d14a4f70ba4e3cf': `Premi Menu se non c'è l'icona Condividi`,
's922329d6f6213590': `Aggiungi al Dock`,
's9c63a79ffcc2a3a3': `Premi "Aggiungi alla schermata principale"`,
'sa2d71bfd9525168d': `Premi "Aggiungi al Dock"`,
'sa5ef80b4bb9b39f8': `Meno`,
'sb527eca1c1d7e7be': `Apri il menu del browser integrato`,
'sba52286c21552a4e': `Installalo sul tuo dispositivo per un'esperienza più completa e un accesso facile.`,
'sc16e00a7a8b2fde2': `Indietro`,
'scdaf4bbff76674c8': `Aggiungi alla schermata principale`,
'sd18a5b85f599ff3c': `Apri il link copiato in Safari`,
'se72fc3a84f9b51c3': `Tocca per copiare il link`,
'se740f75b95a51807': `Aggiungilo al Dock per un'esperienza più completa e un accesso facile.`,
'sfa6c42cdf48d93d2': `Ma questo browser non supporta questa funzionalità. Apri il link in un browser esterno per continuare.`,
'sfb78526365796a41': `Premi "Mostra altro" nel menu Condividi`,
'sfea652f6580ff086': `Questo sito ha funzionalità di app.`,
    };
  